const IconFilledEmail = () => {
  return (
    <path
      d="M7.69391 6.79656C7.97914 6.79656 8.24348 6.66436 8.54956 6.35829L14.6018 0.368696C14.3444 0.118261 13.8644 0 13.1757 0H1.97565C1.39131 0 0.980869 0.111305 0.751303 0.34087L6.83826 6.35829C7.13738 6.65742 7.40179 6.79656 7.69391 6.79656ZM0.173914 10.8661L5.09218 6.00348L0.16 1.14087C0.0556523 1.33566 0 1.66957 0 2.14957V9.82957C0 10.3235 0.0556523 10.6713 0.173914 10.8661ZM2.18435 11.9861H13.3844C13.9687 11.9861 14.3722 11.8748 14.6018 11.6522L9.58609 6.68526L9.12698 7.15131C8.64697 7.61048 8.19481 7.81914 7.69391 7.81914C7.18612 7.81914 6.73396 7.61048 6.2609 7.15131L5.7948 6.68526L0.793047 11.6452C1.05739 11.8748 1.51653 11.9861 2.18435 11.9861ZM15.1931 10.8592C15.3044 10.6574 15.36 10.3165 15.36 9.82957V2.14957C15.36 1.68349 15.3044 1.34957 15.207 1.16174L10.2887 6.00348L15.1931 10.8592Z"
      fill="currentColor"
      data-testid="icon-filled-email"
    />
  );
};

export default IconFilledEmail;
